const getDisplayData = (tariff) => (tariff && tariff.displayData) ? tariff.displayData : {};

export class BaseCarrierUiExtension {
    getShortTariffTitle(tariff) {
        const displayData = getDisplayData(tariff);
        return displayData.carrierServiceShortTitle
            || displayData.carrierServiceName
            || (tariff && tariff.carrierServiceShortTitle)
            || (tariff && tariff.carrierServiceName)
            || '';
    }

    isCourierMessageAvailable() {
        return false;
    }

    usePrimaryPhoneOnly() {
        return false;
    }

    getPhoneHintText() {
        return '';
    }

    moveExtraPhonesToAddressComments(form) {
        return null;
    }

    onTariffSelected({changeParam}) {
        changeParam('vehicleTypeId', null);
    }
}




// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/carrierExtensions/baseCarrierUiExtension.js